import React, { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { store } from "../store";
import { observer } from "mobx-react-lite";

export const Alert: FC = observer(() => {
  const { showAlert, changeAlertState, alertDialog } = store;
  const { title, message, error } = alertDialog || {};

  return (
    <div>
      <Dialog open={showAlert} onClose={changeAlertState}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
          <small>{error}</small>
        </DialogContent>
        <DialogActions>
          <Button onClick={changeAlertState}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});
